import FormSelect from '../../atoms/FormSelect';
import { useEffect } from 'react';

const StudentSearch = ({ setSearchString, refetch }) => {
  useEffect(() => {
    if (sessionStorage.getItem('studentSearchString') !== null) {
      document.getElementById('searchString').value = sessionStorage.getItem(
        'studentSearchString'
      );
      submitSearchQuery(sessionStorage.getItem('studentSearchString'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchOptions = [
    {
      id: 'studentName',
      value: 'Name',
    },
    {
      id: 'idnumber',
      value: 'BC/FIN',
    },
    {
      id: 'student_id',
      value: 'UID',
    },
  ];
  const handleKeyPresses = e => {
    if (e.key === 'Enter') {
      submitSearchQuery(e.target.value);
    }
  };

  const submitSearchQuery = query => {
    if (query !== '') sessionStorage.setItem('studentSearchString', query);
    else sessionStorage.removeItem('studentSearchString');
    setSearchString(query);
  };

  return (
    <div>
      <FormSelect
        propId='searchPredicate'
        options={searchOptions}
        valueKey='id'
        labelKey='value'
        blankOption={false}
        changeHandler={refetch}
        ariaLabel='Search By'
      />

      <input
        id='searchString'
        type='text'
        placeholder='Student Search'
        className='rounded-sm border border-solid border-gray-300 px-2 py-1'
        style={{
          minWidth: '200px',
        }}
        onKeyUp={handleKeyPresses}
        aria-label='Student Search'
        data-cy='search-string-input'
      />
    </div>
  );
};

export default StudentSearch;
